import messageEvents from 'events/messages';
import messageSelectors from 'selectors/messages';
import sendMessage from 'actions/messages/sendMessage';

export default function sendPendingMessages(dispatch, getState) {
  const state = getState();
  const pendingAttachments = messageSelectors.getPendingAttachments(state.messages);
  const pendingMessages = messageSelectors.getPendingMessages(state.messages);

  if (pendingMessages.length) {
    pendingMessages.forEach(message => dispatch(sendMessage(message, pendingAttachments)));
    dispatch(messageEvents.clearPendingMessages());
  }

  if (pendingAttachments.length) {
    dispatch(messageEvents.clearPendingAttachments());
  }
}
